/**
 * فهرستِ بازی‌ها — یک منبع، دو مصرف.
 *
 * `catalog` همه‌ی بازی‌های بازی وان است و صفحه‌های سایت (`site/build.ts`) از روی
 * همین ساخته می‌شوند. `games` فقط آن‌هایی است که سرور واقعاً می‌شناسد و کلاینت
 * می‌تواند بازی‌شان کند؛ شناسه‌هایش باید دقیقاً همانی باشد که سرور دارد
 * (Backend/internal/match/match.go → Games). یک‌بار «charbarg» فرستادیم و سرور
 * «unsupported_game» داد؛ آزمونِ کنارِ همین فایل نگهش می‌دارد.
 *
 * `online: false` یعنی بازی در اپِ اندروید هست ولی هنوز میزِ آنلاین ندارد —
 * صفحه‌اش ساخته می‌شود، ولی دکمه‌اش به کافه‌بازار می‌رود نه به میز.
 */
export type Pip = "spade" | "heart" | "diamond" | "club" | "joker" | "star";

export type Game = {
  /** شناسه‌ی سرور؛ نامِ فایلِ صفحه‌ی بازی هم همین است. */
  id: string;
  fa: string;
  en: string;
  /** تعدادِ نفرات — زیرِ نامِ بازی می‌نشیند. */
  note: string;
  /** هدفِ بازی در یک جمله. */
  blurb: string;
  color: string;
  pip: Pip;
  online: boolean;
  /** «چطور بازی کنیم» — سه تا پنج بند. */
  rules: string[];
};

export const catalog: Game[] = [
  {
    id: "hokm",
    fa: "حکم",
    en: "Hokm",
    note: "۲ تا ۶ نفره",
    blurb: "حکم بزن و دست‌ها را ببر",
    color: "linear-gradient(180deg,#5b9aa9,#3c6f80)",
    pip: "spade",
    online: true,
    rules: [
      "چهار نفر، دو تیمِ روبه‌رو؛ به هر کس سیزده کارت می‌رسد.",
      "اولین کسی که آس بگیرد حاکم می‌شود: پنج کارتِ اولش را می‌بیند و «حکم» — خالِ برتر — را اعلام می‌کند.",
      "اگر از خالِ زمین داری باید همان را بریزی؛ نداری، هر چیزی — از جمله حکم، برای بریدن.",
      "بالاترین کارتِ حکم دست را می‌برد، و اگر حکمی نیفتاده باشد بالاترین کارتِ خالِ زمین.",
      "هر تیم زودتر هفت دست بگیرد آن دست را با یک امتیاز می‌برد؛ هفت بر صفر «کُت» است و دو امتیاز. اولین تیم با هفت امتیاز، مسابقه را می‌برد.",
    ],
  },
  {
    id: "chahar",
    fa: "چهاربرگ",
    en: "Chahar Barg",
    note: "۲ تا ۴ نفره",
    blurb: "با مجموعِ یازده بردار",
    color: "linear-gradient(180deg,#7d5bb0,#553b80)",
    pip: "diamond",
    online: true,
    rules: [
      "به هر نفر چهار برگ می‌رسد و چهار برگ روی زمین باز است.",
      "کارتِ عددی فقط وقتی برمی‌دارد که مجموعش با کارت‌های زمین دقیقاً یازده شود. بی‌بی با بی‌بی و شاه با شاه.",
      "سرباز همه‌ی کارت‌های عددی و سربازهای زمین را جارو می‌کند — ولی بی‌بی و شاه را نه.",
      "خالی‌کردنِ کاملِ زمین «سور» است و پنج امتیاز دارد.",
      "امتیازِ هر دور بیست است: هفت‌خاج ۷، ۱۰ خشت ۳، ۲ گشنیز ۲، هر آس ۱ و هر سرباز ۱. شمارِ کارت خودش امتیازی ندارد.",
    ],
  },
  {
    id: "haft",
    fa: "هفت خبیث",
    en: "Haft Khabis",
    note: "۲ تا ۶ نفره",
    blurb: "زودتر دستت را خالی کن",
    color: "linear-gradient(180deg,#c8504a,#933531)",
    pip: "heart",
    online: true,
    rules: [
      "هم‌خال یا هم‌عددِ کارتِ رو بگذار تا زودتر از همه دستت خالی شود؛ نداشتی، از پشته بکش.",
      "هفت کارتِ خبیث بازی را برمی‌گردانند: ۷ نفرِ بعد را دو برگ جریمه می‌کند و روی هم جمع می‌شود، ۱۰ جهت را برمی‌گرداند، آس نوبت را می‌سوزاند، سرباز خال را عوض می‌کند و بمب همه را می‌کِشاند.",
      "سه کارتِ دفاعی — آینه، سپر و پنهان — اثرِ خبیث‌ها را برمی‌گردانند یا خنثی می‌کنند.",
      "وقتی یک برگ بیشتر نداری «هشدار» را بزن، وگرنه جریمه می‌شوی.",
    ],
  },
  {
    id: "shelam",
    fa: "شلم",
    en: "Shelem",
    note: "۴ نفره تیمی",
    blurb: "شرط ببند و دست بگیر",
    color: "linear-gradient(180deg,#d9a441,#a97327)",
    pip: "club",
    online: true,
    rules: [
      "چهار نفر، دو تیمِ روبه‌رو؛ به هر کس دوازده برگ می‌رسد و چهار برگ زمین می‌مانَد.",
      "مزایده از صد به بالا و مضربِ پنج. آخرین خواننده حکم را اعلام می‌کند و باید به تعهدش برسد.",
      "ارزش‌ها: هر آس ده، هر ۱۰ ده، هر ۵ پنج، به‌علاوه‌ی پنج برای هر دست و پنج برای زمین — روی هم ۱۶۵.",
      "زیرِ تعهد ولی بالای ۸۵ «کُت» است و به اندازه‌ی تعهدت منفی می‌گیری؛ زیرِ ۸۵ «یاسا» است و ۱۶۵− .",
      "بردنِ همه‌ی دست‌ها «شلم» است و ۳۳۰ امتیاز دارد.",
    ],
  },
  {
    id: "rami",
    fa: "رامی",
    en: "Rummy",
    note: "۲ تا ۴ نفره",
    blurb: "دسته و رشته بچین",
    color: "linear-gradient(180deg,#4f9e6a,#347148)",
    pip: "club",
    online: false,
    rules: [
      "به هر کس سیزده برگ می‌رسد.",
      "در نوبتت یک کارت بکش — از دسته یا از دورریز — و یکی دور بینداز.",
      "کلِ دستت را به «سری» (هم‌رتبه) و «دنباله» (هم‌خالِ پشتِ سرِ هم) بچین تا اعلام کنی.",
      "جوکر جای هر کارتی می‌نشیند.",
      "کم‌ترین جریمه تا صد امتیاز، برنده است.",
    ],
  },
  {
    id: "basicrami",
    fa: "رامیِ کلاسیک",
    en: "Classic Rummy",
    note: "۲ تا ۴ نفره",
    blurb: "روی میز بچین و بچسبان",
    color: "linear-gradient(180deg,#7ba050,#55703a)",
    pip: "club",
    online: false,
    rules: [
      "یک دسته‌ی ۵۲ برگی بی‌جوکر: دو نفره ده برگ، سه و چهار نفره هفت برگ.",
      "یک کارت بکش، بعد هر سری و دنباله‌ای که داری روی میز باز کن.",
      "می‌توانی کارتت را به چیده‌های روی میزِ بقیه هم بچسبانی. آخرِ نوبت یک کارت دور بینداز.",
      "هر کس اول دستش خالی شود دور را می‌برد و به اندازه‌ی کارت‌های مانده در دستِ بقیه امتیاز می‌گیرد (آس ۱، سرباز و بی‌بی و شاه ۱۰).",
      "اولین نفر تا ۵۰۰ امتیاز، برنده است.",
    ],
  },
  {
    id: "gin",
    fa: "جین رامی",
    en: "Gin Rummy",
    note: "۲ نفره",
    blurb: "با کم‌ترین کارتِ نچیده ناک بزن",
    color: "linear-gradient(180deg,#4fa0b8,#357285)",
    pip: "diamond",
    online: false,
    rules: [
      "دو نفره؛ به هر کس ده برگ می‌رسد.",
      "یک کارت بکش و یکی دور بینداز؛ کارت‌ها را به سری و دنباله بچین.",
      "کارت‌های نچیده جریمه دارند: آس ۱، سرباز و بی‌بی و شاه ۱۰، بقیه عددِ خودشان.",
      "نچیده‌ات که ده یا کمتر شد می‌توانی «ناک» بزنی و دست را ببندی؛ صفر باشد «جین» است و ۲۵ امتیازِ اضافه دارد.",
      "اولین نفر تا صد امتیاز، برنده است.",
    ],
  },
  {
    id: "bluff",
    fa: "بلوف",
    en: "Bluff",
    note: "۳ تا ۶ نفره",
    blurb: "بلوف بزن، مچت را نگیرند",
    color: "linear-gradient(180deg,#d97b3c,#a4552a)",
    pip: "joker",
    online: false,
    rules: [
      "کلِ ۵۲ برگ بینِ همه پخش می‌شود و هر دور یک رتبه ادعا می‌شود.",
      "در نوبتت یک تا چهار برگ پشت‌رو بگذار و بگو همان رتبه است — راست یا دروغ.",
      "می‌توانی پاس بدهی، یا نفرِ قبل را «شک» کنی.",
      "شکِ درست: بلوف‌زن کلِ زمین را برمی‌دارد. شکِ اشتباه: خودت برمی‌داری.",
      "هر کس زودتر دستش را راست‌راستکی خالی کند، برنده است.",
    ],
  },
  {
    id: "sheytan",
    fa: "بازی شیطان",
    en: "Old Maid",
    note: "۳ تا ۶ نفره",
    blurb: "جوکر دستت نماند وگرنه شیطانی!",
    color: "linear-gradient(180deg,#b8508f,#853665)",
    pip: "joker",
    online: false,
    rules: [
      "۵۲ برگ به‌اضافه‌ی یک جوکر. همه پخش می‌شود و هر کس اول جفت‌های هم‌رتبه‌اش را می‌اندازد.",
      "در نوبتت یک برگِ ندیده از دستِ حریفِ سمتِ راستت بکش.",
      "جفت شد، هر دو را بینداز و دوباره بکش؛ نشد، نوبتت تمام است.",
      "جوکر با هیچ برگی جفت نمی‌شود — آخرِ بازی دستِ هر کس بماند، شیطان است.",
      "اولین کسی که دستش خالی شود، «شاه» است.",
    ],
  },
  {
    id: "bidel",
    fa: "بی‌دل",
    en: "Hearts",
    note: "۴ نفره",
    blurb: "دل و بی‌بی‌پیک نگیر",
    color: "linear-gradient(180deg,#b34a5e,#822f41)",
    pip: "heart",
    online: false,
    rules: [
      "چهار نفر، هر کس برای خودش؛ به هر نفر سیزده برگ می‌رسد.",
      "پیش از هر دست سه کارت رد و بدل می‌شود، و دارنده‌ی ۲ گشنیز دستِ اول را با همان شروع می‌کند.",
      "هم‌خالِ زمین بریز. تا کسی دل نریخته، نمی‌شود دل سرداد.",
      "هر دل یک امتیازِ منفی دارد و بی‌بی‌پیک سیزده — روی هم ۲۶ در هر دست. کم‌ترین امتیاز می‌برد.",
      "ولی اگر یک نفر هر ۲۶ را یک‌جا بگیرد «شوتِ ماه» است: خودش صفر می‌شود و آن سه نفرِ دیگر ۲۶ می‌گیرند.",
    ],
  },
  {
    id: "salter",
    fa: "سالتر",
    en: "Solitaire",
    note: "۱ نفره",
    blurb: "یک‌نفره: کارت‌ها را بچین",
    color: "linear-gradient(180deg,#5a63b5,#3d4482)",
    pip: "spade",
    online: false,
    rules: [
      "یک‌نفره؛ هفت ستون که در هر کدام فقط کارتِ رویی باز است.",
      "روی ستون‌ها نزولی و با رنگِ متناوب بچین — شش سیاه روی هفت قرمز.",
      "ستونِ خالی فقط شاه می‌پذیرد.",
      "از دسته کارت بکش؛ ته که کشید، دوباره می‌چرخد.",
      "هر چهار خانه‌ی پایه را از آس تا شاه و هم‌خال بچین تا ببری.",
    ],
  },
  {
    id: "bibi",
    fa: "بی‌بی سلام",
    en: "Bibi Salaam",
    note: "۳ تا ۴ نفره",
    blurb: "کندترین دست، کارت‌ها را برمی‌دارد",
    color: "linear-gradient(180deg,#5c7fb8,#3d5885)",
    pip: "star",
    online: false,
    rules: [
      "کلِ ۵۲ برگ بینِ همه پخش می‌شود و هر کس دسته‌اش را پشت‌رو نگه می‌دارد.",
      "نوبتی یک کارت از رویِ دسته‌ات وسط بینداز. روی کارتِ عددی فقط تماشا کن.",
      "کارتِ صورت که رو شد باید فوری واکنش بدهی: آس دست زدن، شاه سلامِ نظامی، بی‌بی گفتنِ «بی‌بی سلام!» و سرباز سلام.",
      "کندترین نفر همه‌ی کارت‌های وسط را برمی‌دارد — و این بد است.",
      "هر کس زودتر دسته‌اش تمام شود، برنده است.",
    ],
  },
  {
    id: "bridge",
    fa: "بریج",
    en: "Bridge",
    note: "۴ نفره تیمی",
    blurb: "قرارداد ببند و دست بگیر",
    color: "linear-gradient(180deg,#a97b4f,#7b5637)",
    pip: "spade",
    online: false,
    rules: [
      "چهار نفر، دو تیمِ روبه‌رو؛ به هر کس سیزده برگ می‌رسد.",
      "اول مزایده: نوبتی بید می‌زنی — سطحِ یک تا هفت به‌اضافه‌ی یک خال یا «بی‌حکم» — یا پاس و دوبل.",
      "بالاترین بید «قرارداد» می‌شود و خالش حکم است.",
      "دستِ یارِ اعلام‌کننده روی میز باز می‌شود و خودش هر دو دست را بازی می‌کند.",
      "باید شش به‌اضافه‌ی سطحِ قرارداد دست بگیری؛ نرسی، جریمه به حریف می‌رسد.",
    ],
  },
];

/** آن‌هایی که میزِ آنلاین دارند — تنها چیزی که کلاینت می‌تواند بفرستد. */
export const games = catalog.filter((g) => g.online);
